import { ActionIcon, Tooltip } from '@mantine/core'
import { Copy, Trash2 } from 'lucide-react'

import { toast } from 'src/components/Overlays/Toast/Toast'

interface ActionsCellProps {
  pkg: {
    packageId: string
  }
  setSelectedPackageId: (id: string) => void
  deleteModalHandlers: {
    open: () => void
  }
}

const ActionsCell = ({
  pkg,
  setSelectedPackageId,
  deleteModalHandlers,
}: ActionsCellProps) => (
  <div className="flex items-center justify-center gap-4">
    <Tooltip label={pkg.packageId}>
      <ActionIcon
        variant="subtle"
        color="gray"
        onClick={(e) => {
          e.stopPropagation()
          navigator.clipboard.writeText(pkg.packageId)
          toast('Copied to clipboard', 'success')
        }}
      >
        <Copy size={12} className="stroke-doubleNickel-gray-500" />
      </ActionIcon>
    </Tooltip>
    <ActionIcon
      variant="subtle"
      color="red"
      onClick={(e) => {
        e.stopPropagation()
        setSelectedPackageId(pkg.packageId)
        deleteModalHandlers.open()
      }}
    >
      <Trash2 size={12} className="stroke-red-600" />
    </ActionIcon>
  </div>
)

export default ActionsCell
